@if (isMobile()) {
  <mat-tab-group animationDuration="0ms" data-testid="email-ui-builder-v3-page">
    <mat-tab label="Edit" data-testid="email-ui-builder-v3-page-edit-tab">
      <ng-template matTabContent>
        <email-builder-editor
          data-testid="email-ui-builder-v3-page-editor"
          [initialContentData]="initialContentData()"
          (contentDataChange)="onContentDataChange($event)"
          (isValidChange)="onValidChange($event)"
        />
      </ng-template>
    </mat-tab>
    <mat-tab label="Preview" data-testid="email-ui-builder-v3-page-preview-tab">
      <ng-template matTabContent>
        <email-builder-preview
          data-testid="email-ui-builder-v3-page-preview-panel"
          [renderedHtml]="previewHtml()"
          [subject]="previewSubject()"
          [previewText]="previewPreviewText()"
          [contactProvider]="contactProvider"
          [saveDisabled]="!isValid()"
          (saveClicked)="onSaveClicked()"
          (sendPreviewClicked)="onSendPreviewClicked()"
          (contactSelected)="selectedContact.set($event)"
        />
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <div class="desktop-layout" data-testid="email-ui-builder-v3-page">
    <glxy-resize width="400px" minWidth="300px" maxWidth="70%" appearance="standard">
      <email-builder-editor
        data-testid="email-ui-builder-v3-page-editor"
        [initialContentData]="initialContentData()"
        (contentDataChange)="onContentDataChange($event)"
        (isValidChange)="onValidChange($event)"
      />
    </glxy-resize>
    <div class="preview-panel">
      @if (preview.isLoading()) {
        <mat-progress-bar mode="indeterminate" />
      }
      <email-builder-preview
        data-testid="email-ui-builder-v3-page-preview-panel"
        [renderedHtml]="previewHtml()"
        [subject]="previewSubject()"
        [previewText]="previewPreviewText()"
        [contactProvider]="contactProvider"
        [saveDisabled]="!isValid()"
        (saveClicked)="onSaveClicked()"
        (sendPreviewClicked)="onSendPreviewClicked()"
        (contactSelected)="selectedContact.set($event)"
      />
    </div>
  </div>
}
